export default function updateAssignedTo(state, action) {
  const { question, userId } = action.payload;
  state.questionList.forEach((q) => {
    if (q._id === question._id) {
      q.assigned_to = userId;
    }
  });
}
